import { takeEvery, put, call, select, delay } from 'redux-saga/effects'
import {
  API_SERVER,
  GET_NEW_SALARY_START,
  SELECT_ROW_SALARY,
  POST_SALARY,
  GET_SALARY_INFO,
  SAVE_SALARY_SLIP,
  SEND_REFERRAL_CODE,
  DISCOUNT_IS_NOT_USED,
  GET_SALARIES_START
} from '../constants/index'
import {
  getNewSalarySuccess,
  selectRowSalarySuccess,
  getSalariesSuccess,
  getSalaryByIdSuccess,
  addSalarySuccess,
  addSalaryFailure,
  clearSalarySelection,
  sendReferralCodeSuccess,
  sendReferralCodeFailed,
  getReferralDiscountDetailsSuccess,
  getReferralDiscountDetailsFailed,
  getReferralDiscountByEmail,
  discountIsNotUsedSuccess,
  discountIsNotUsedFailed
} from '../actions/index'
import store from '../store'
import { apiManualPost, apiBlobPost } from '../utils/request'
import {
  getFirstName,
  getLastName,
  getLoggedInEmail,
  getUserType
} from '../selectors/client.selector'
import { getSelectedUser } from '../selectors/adminUser.selector'

function* getNewSalarySaga({ data }) {
  const selectedUser = data
  try {
    const url = `${API_SERVER}/GetInvoiceInfoForWages`

    const uuid = store.getState().client.user.data[2]
    const userType = store.getState().client.user.data[5]

    const body = JSON.stringify({
      uuid: userType == 2 ? selectedUser.uuid : uuid
    })

    const result = yield call(apiManualPost, url, body)

    const resultParsed = JSON.parse(result.data)

    resultParsed[Symbol.iterator] = function* () {
      const keys = Reflect.ownKeys(this)
      for (const key of keys) {
        yield this[key]
      }
    }

    yield put(getNewSalarySuccess(resultParsed))
  } catch (e) {
    // console.warn(e)
  }
}

function* postSalarySaga({ selected }) {
  try {
    let bills = selected.map((el) => ({
      invoice_id: el.invoice_id,
      partial_invoice_id: el.partial_invoice_id,
      member_id: el.member_id,
      invoice_uuid: el.invoice_uuid
    }))

    const salarySummary = store.getState().salary.newSalarySummary
    //console.log('salarySummary:: ',salarySummary)
    const uuid = store.getState().client.user.data[2]

    // KAS-336 Referral program
    const recommendedPersonGetDiscount =
      store.getState().salary.recommendedPersonGetDiscount
    const referrerPersonGetDiscount =
      store.getState().salary.referrerPersonGetDiscount
    const email = yield select(getLoggedInEmail)
    const firstname = yield select(getFirstName)
    const lastname = yield select(getLastName)
    const selectedRows = store.getState().salary.selectedRows
    const gross_salary_without_vat = salarySummary.sumInvWithoutTax
    const instant_payment = salarySummary.instant_payment[0]
    const isGroupInvoice = salarySummary.isGroupInvoice[0] === 1 ? true : false

    const userType = yield select(getUserType)
    const { adminUser } = store.getState()
    const { selectedUser } = adminUser

    const body = JSON.stringify({
      uuid: userType == 2 ? selectedUser.uuid : uuid,
      invoices: bills,
      gross_salary: salarySummary.gross_sum,
      net_salary: salarySummary.net_sum,
      normal_ulosotto: salarySummary.normal_ulosotto_sum,
      brutto_ulosotto: salarySummary.brutto_ulosotto_sum,
      service_cost: salarySummary.service_cost,
      expenses_cost: salarySummary.allowances_cost,
      expense_cost_without_vat: salarySummary.expense_cost_without_vat,
      reimbursment_cost: salarySummary.expenses_cost,
      take_home_pay: salarySummary.paid_sum,
      tax_cost: salarySummary.tax_percentage,
      yel_cost: salarySummary.yel_insurance,
      social_contribution: salarySummary.social_contri,
      sumWithoutTax: salarySummary.sumInvWithoutTax,
      sumWithTax: salarySummary.sumWithTax,
      palkka: salarySummary.palkka,
      deductions_sum: salarySummary.deductions_sum
    })
    const url = `${API_SERVER}/AddSalary`
    let resultAddSalary
    if (salarySummary.paid_sum > 0) {
      resultAddSalary = yield call(apiManualPost, url, body)
      if (resultAddSalary.data === 'Salary saved successfully!') {
        yield put(addSalarySuccess(resultAddSalary.data))

        // KAS 336 update that the recommended and referrer person have usede the discount
        if (
          ((recommendedPersonGetDiscount &&
            gross_salary_without_vat >= 500 &&
            instant_payment !== 'quick_pay' &&
            !isGroupInvoice) ||
            (referrerPersonGetDiscount &&
              instant_payment !== 'quick_pay' &&
              !isGroupInvoice)) &&
          selectedRows.length === 1 &&
          resultAddSalary.data === 'Salary saved successfully!'
        ) {
          const discountUrl = `${API_SERVER}/GetReferralDiscountDetails`
          const discountBody = JSON.stringify({
            email: userType == 2 ? selectedUser.email : email,
            firstname: userType == 2 ? selectedUser.firstname : firstname,
            lastname: userType == 2 ? selectedUser.lastname : lastname
          })
          const discountResult = yield call(
            apiManualPost,
            discountUrl,
            discountBody
          )
          yield put(getReferralDiscountDetailsSuccess(discountResult.data))
          yield put(getReferralDiscountByEmail(selectedUser))
        }

        yield delay(1000)
        // Reload the page after successful execution
        window.location.reload()
      } else {
        yield put(addSalaryFailure())
      }
      //Update Salary Grid after Add Salary
      const getSalaryUrl = `${API_SERVER}/GetSalaries`
      const getSalaryBody = JSON.stringify({
        uuid: userType == 2 ? selectedUser.uuid : uuid
      })
      const resultGetSalaries = yield call(
        apiManualPost,
        getSalaryUrl,
        getSalaryBody
      )
      const resultParsed = JSON.parse(resultGetSalaries.data)
      yield put(getSalariesSuccess(resultParsed))

      //Update Invoice Info Grid after Add Salary
      const invoiceInfoUrl = `${API_SERVER}/GetInvoiceInfoForWages`
      const invoiceInfoBody = JSON.stringify({
        uuid: userType == 2 ? selectedUser.uuid : uuid
      })
      const resultInvoiceInfo = yield call(
        apiManualPost,
        invoiceInfoUrl,
        invoiceInfoBody
      )
      const resultParsedInvoiceInfo = JSON.parse(resultInvoiceInfo.data)

      yield put(getNewSalarySuccess(resultParsedInvoiceInfo))
      yield put(clearSalarySelection())
      yield put(getReferralDiscountByEmail(selectedUser))
    } else {
      yield put(addSalaryFailure())
    }
  } catch (e) {
    // console.warn(e)
    yield put(clearSalarySelection())
    yield put(getReferralDiscountDetailsFailed(discountResult.data))
  }
}

function* getSalariesSaga({ data }) {
  const selectedUser = data
  try {
    const url = `${API_SERVER}/GetSalaries`

    const uuid = store.getState().client.user.data[2]
    const userType = store.getState().client.user.data[5]

    const body = JSON.stringify({
      uuid: userType == 2 ? selectedUser.uuid : uuid
    })

    const result = yield call(apiManualPost, url, body)
    const resultParsed = JSON.parse(result.data)
    //console.log('getSalariesSaga:: ', resultParsed)

    yield put(getSalariesSuccess(resultParsed))
  } catch (e) {
    // console.warn(e)
  }
}

function* selectRowSalarySaga() {
  try {
    const uuid = store.getState().client.user.data[2]
    const userType = store.getState().client.user.data[5]
    const { adminUser } = store.getState()
    const { selectedUser } = adminUser

    const taxUrl = `${API_SERVER}/GetSalaryTaxPercentagesbyUUID`
    const body = JSON.stringify({
      uuid: userType == 2 ? selectedUser.uuid : uuid
    })
    const taxResult = yield call(apiManualPost, taxUrl, body)
    const resultParsed = JSON.parse(taxResult.data)

    yield put(
      selectRowSalarySuccess({
        taxResult: resultParsed
      })
    )
  } catch (e) {
    // console.warn(e)
  }
}

function* getSalaryByIdSaga({ id }) {
  try {
    const url = `${API_SERVER}/GetSalaryByID`
    const uuid = store.getState().client.user.data[2]
    const userType = store.getState().client.user.data[5]
    const { adminUser } = store.getState()
    const { selectedUser } = adminUser

    const body = JSON.stringify({
      id: id,
      uuid: userType == 2 ? selectedUser.uuid : uuid
    })
    const result = yield call(apiManualPost, url, body)
    const resultParsed = JSON.parse(result.data)
    yield put(getSalaryByIdSuccess(resultParsed))
    const section = document.getElementById('salary-info-scroll-section')
    section.scrollIntoView({ behavior: 'smooth' })
  } catch (e) {
    // console.warn(e)
  }
}

function* saveSalarySlip({ id, invoice_uuid }) {
  try {
    const url = `${API_SERVER}/GenerateSalaryPDF`
    const uuid = store.getState().client.user.data[2]

    const userType = store.getState().client.user.data[5]

    const { adminUser } = store.getState()
    const { selectedUser } = adminUser

    const body = JSON.stringify({
      id: id,
      uuid: userType == 2 ? selectedUser.uuid : uuid,
      invoice_uuid: invoice_uuid
    })
    yield call(apiBlobPost, url, body)
  } catch (e) {
    // console.warn(e)
  }
}

// KAS-336 send referral code
function* sendReferralCodeSaga({ data }) {
  try {
    const url = `${API_SERVER}/UpdateReferralUserDetails`
    const email = yield select(getLoggedInEmail)
    const userType = yield select(getUserType)
    const selectedUser = yield select(getSelectedUser)
    const body = JSON.stringify({
      recommendedpersonemail: userType == 2 ? selectedUser.email : email,
      ReferralCodeUser: data.referralCode
    })

    const result = yield call(apiManualPost, url, body)

    if (
      result.data === 'Referral program information updated successfully' ||
      result.data === 'Recommended person denied the referral program'
    ) {
      yield put(sendReferralCodeSuccess(result.data))
      yield put(getReferralDiscountByEmail(selectedUser))

      yield delay(1000)
      // Reload the page after successful execution
      window.location.reload()
    } else {
      yield put(sendReferralCodeFailed(result.data))
    }
  } catch (error) {
    yield put(sendReferralCodeFailed(error))
  }
}

// KAS-385 send never use discount
function* discountIsNotUsedSaga() {
  try {
    const url = `${API_SERVER}/UpdateReferralUserDetails`
    const email = yield select(getLoggedInEmail)
    const userType = yield select(getUserType)
    const selectedUser = yield select(getSelectedUser)
    const body = JSON.stringify({
      recommendedpersonemail: userType == 2 ? selectedUser.email : email,
      ReferralCodeUser: '@denyDiscount'
    })

    const result = yield call(apiManualPost, url, body)

    if (
      result.data === 'Referral program information updated successfully' ||
      result.data === 'Recommended person denied the referral program'
    ) {
      yield put(discountIsNotUsedSuccess(result.data))
      yield put(getReferralDiscountByEmail(selectedUser))
    } else {
      //KAS-385 Currently unused action.
      // If this action is triggered, developer can check at Inspect tool
      yield put(discountIsNotUsedFailed(result.data))
    }
  } catch (error) {
    yield put(discountIsNotUsedFailed(error))
  }
}

export function* watchGetNewSalarySaga() {
  yield takeEvery(GET_NEW_SALARY_START, getNewSalarySaga)
}

export function* watchSelectRowSalarySaga() {
  yield takeEvery(SELECT_ROW_SALARY, selectRowSalarySaga)
}

export function* watchPostSalarySaga() {
  yield takeEvery(POST_SALARY, postSalarySaga)
}

export function* watchGetSalariesSaga() {
  yield takeEvery(GET_SALARIES_START, getSalariesSaga)
}

export function* watchGetSalaryByIdSaga() {
  yield takeEvery(GET_SALARY_INFO, getSalaryByIdSaga)
}

export function* watchSaveSalarySlipSaga() {
  yield takeEvery(SAVE_SALARY_SLIP, saveSalarySlip)
}

export function* watchSendReferralCodeSaga() {
  yield takeEvery(SEND_REFERRAL_CODE, sendReferralCodeSaga)
}

export function* watchDiscountIsNotUsedSaga() {
  yield takeEvery(DISCOUNT_IS_NOT_USED, discountIsNotUsedSaga)
}
